import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Line } from 'react-chartjs-2';
import { CategoryScale, Chart, LinearScale, registerables } from "chart.js";
import { makeStyles } from '@material-ui/styles';
import { useChartOptions } from './chart';
import 'firebase/database';
import { getDatabase, ref, onValue, get, child } from 'firebase/database';

import i18n from 'i18n/i18n';  // i18n 객체 직접 import
import 'intl-pluralrules';


Chart.register(...registerables);




const VGICapacities = props => {
  const { className, ...rest } = props;

  const options = useChartOptions();


  // const labels = ['1min', '5min', '30min', '1hr', '4hr'];
  // const datas = [111, 111, 112, 123, 145];

  const database = getDatabase();
  const dbRef = ref(database);

  const classes = useStyles();


  const [viewData, setViewData] = useState({
    labels: ['1min', '5min', '30min', '1hr', '4hr'],
    datasets:[],
  });




  const makeSampleData = (min1, min5, min30, hour1, hour4,
    min1_down, min5_down, min30_down, hour1_down, hour4_down,
    ) =>{

    const viewdata = {
      labels: ['1min', '5min', '30min', '1hr', '4hr'],
      datasets: [
        {
          id:1,
          label: i18n.t("up"),
          // data: [33, 153, 285, 1341, 2844],
          data: [min1, min5, min30, hour1, hour4],
          fill: true,
          // backgroundColor: "rgba(75,192,192,0.2)",
          // borderColor: "rgba(75,192,192,1)"
          backgroundColor: "rgba(219, 101, 37,0.2)",
          borderColor: "rgba(219, 101, 37,1)"
        },
        {
          id:2,
          label: i18n.t("down"),
          // data: [31, 12.5, 23.5, 11.51, 25.54],
          data: [min1_down, min5_down, min30_down, hour1_down, hour4_down],
          fill: false,
          // borderColor: "#742774"
          borderColor: "#307c21"
        }
      ]
    };


    setViewData(viewdata);

  }

  // simu/instantaneous/vgi_capacity

  useEffect(() => {
    onValue(child(dbRef, 'simu/instantaneous/vgi_capacity'), (snapshot) => {
      makeSampleData(snapshot.val().min1, snapshot.val().min5, snapshot.val().min30,
      snapshot.val().hour1, snapshot.val().hour4,
      snapshot.val().min1_down, snapshot.val().min5_down, snapshot.val().min30_down,
      snapshot.val().hour1_down, snapshot.val().hour4_down
      );
    });


  }, []);



  return (
    <div style={{height:280}}>
      <Line
        data={viewData}
        options={options}
        // height={100}
        width={340}
        // height={"100%"}
      />
    </div>
  );
};

VGICapacities.propTypes = {
  className: PropTypes.string
};


export default VGICapacities;


const useStyles = makeStyles((theme) => ({
  root: {},
  chartContainer: {
    //360px 이상
    ['@media (min-height:360px)']: {// eslint-disable-line no-useless-computed-key
      height: 360,
    },
    //360px 이하
    ['@media (max-height:360px)']: {// eslint-disable-line no-useless-computed-key
      height: 220,
    },
    position: 'relative'
  },
  actions: {
    justifyContent: 'flex-end'
  },
  title: {
    fontWeight: 600,
    // marginTop: theme.spacing(1),
    // marginBottom: theme.spacing(2),
  },
  title2: {
    fontWeight: 800,
  }
}));
